// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.filter-bar .select[data-v-b714c732] {\n  max-width: 200px !important; /* its like 1996 again wtf */\n}\n.table-card[data-v-b714c732] {\n  max-height: none !important;\n}\n", ""]);
// Exports
module.exports = exports;
